import { useCallback, useState } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useShowCauseW_Selector } from '@givebacks/api/core';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container, Grid, SearchInput, SegmentedControl, Stack, Title } from 'ui';
import { useDebouncedValue } from 'ui/Hooks';

import { DirectoryList } from './DirectoryList';
import { NoAccess } from './components/NoAccess';

const Directory = () => {
  const { uuid } = useParams();
  const { data: cause } = useShowCauseW_Selector({ uuid });

  const { isAuthenticated } = useAuthentication();
  const [hasAccess, setHasAccess] = useState(true);

  const [selectedTab, setSelectedTab] = useState<'individuals' | 'families'>('individuals');

  const [searchParams, setSearchParams] = useSearchParams();
  const [debounced] = useDebouncedValue(searchParams.get('search') ?? '', 500);

  const setSearch = useCallback(
    (search: string) => {
      setSearchParams({ search });
    },
    [setSearchParams]
  );

  return (
    <Container size="xl">
      <Grid justify="center" gutter={{ base: 'lg', md: 'xl' }}>
        <Grid.Col span={{ base: 12, md: 6 }} my={{ base: 'none', md: 'lg' }}>
          <Stack gap="lg">
            <Title order={2}>{`${cause?.name ?? ''} Directory`}</Title>
            {hasAccess && isAuthenticated ? (
              <>
                <SegmentedControl
                  fullWidth
                  data={[
                    { label: 'Individuals', value: 'individuals' },
                    { label: 'Families', value: 'families' },
                  ]}
                  variant="light"
                  size="sm"
                  value={selectedTab}
                  onChange={(value) => setSelectedTab(value as 'individuals' | 'families')}
                />

                <Stack>
                  <SearchInput
                    placeholder={`Search all ${selectedTab}`}
                    value={searchParams.get('search') ?? ''}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <DirectoryList
                    groupBy={selectedTab}
                    search={debounced}
                    organizationId={cause?.memberhub_id}
                    setHasAccess={setHasAccess}
                  />
                </Stack>
              </>
            ) : (
              <NoAccess />
            )}
          </Stack>
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export { Directory };
